// Mutfak Mock Data
// Mutfak dolabı, tezgah, ankastre set, evye, davlumbaz takibi

export const mutfakSiparisler = [
    {
        id: 'mt-001', siparisTarihi: '2026-01-12', teslimTarihi: '2026-02-01', tedarikci: 'İstikbal Mobilya',
        tedarikciFirmaId: 'f-050', tur: 'Mutfak Dolabı Alt+Üst', model: 'Premia Serisi', renk: 'Beyaz Parlak',
        miktar: 8, birim: 'set', birimFiyat: 45000, toplamFiyat: 360000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        not: '1. ve 2. kat daireleri montajlandı', createdAt: '2026-01-12T09:00:00Z', updatedAt: '2026-02-05T14:00:00Z',
    },
    {
        id: 'mt-002', siparisTarihi: '2026-01-12', teslimTarihi: '2026-02-01', tedarikci: 'Graniser',
        tedarikciFirmaId: 'f-051', tur: 'Tezgah', model: 'Granit - Nero Assoluto', renk: 'Siyah',
        miktar: 8, birim: 'adet', birimFiyat: 12000, toplamFiyat: 96000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Dolap montajıyla paralel ilerliyor', createdAt: '2026-01-12T09:30:00Z', updatedAt: '2026-02-05T15:00:00Z',
    },
    {
        id: 'mt-003', siparisTarihi: '2026-01-14', teslimTarihi: '2026-01-28', tedarikci: 'Bosch Türkiye',
        tedarikciFirmaId: 'f-052', tur: 'Ankastre Set', model: 'Serie 6 (Fırın+Ocak+Davlumbaz)', renk: 'Siyah',
        miktar: 8, birim: 'set', birimFiyat: 32000, toplamFiyat: 256000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 3, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'Dolap montajı tamamlanan dairelere montaj', createdAt: '2026-01-14T10:00:00Z', updatedAt: '2026-02-03T11:00:00Z',
    },
    {
        id: 'mt-004', siparisTarihi: '2026-01-13', teslimTarihi: '2026-01-25', tedarikci: 'Franke',
        tedarikciFirmaId: 'f-053', tur: 'Evye', model: 'Logica LLX 611-79', renk: 'Krom',
        miktar: 16, birim: 'adet', birimFiyat: 5500, toplamFiyat: 88000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 8, insaatId: 'c1', blokAdi: 'A-B Blok',
        not: 'A Blok tamamlandı, B Blok başlıyor', createdAt: '2026-01-13T08:00:00Z', updatedAt: '2026-01-30T16:00:00Z',
    },
    {
        id: 'mt-005', siparisTarihi: '2026-01-15', teslimTarihi: null, tedarikci: 'İstikbal Mobilya',
        tedarikciFirmaId: 'f-050', tur: 'Mutfak Dolabı Alt+Üst', model: 'Premia Serisi', renk: 'Antrasit',
        miktar: 8, birim: 'set', birimFiyat: 48000, toplamFiyat: 384000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c1', blokAdi: 'B Blok',
        not: 'B Blok iç işleri bitmeli', createdAt: '2026-01-15T11:00:00Z', updatedAt: '2026-01-15T11:00:00Z',
    },
    {
        id: 'mt-006', siparisTarihi: '2026-01-16', teslimTarihi: null, tedarikci: 'Graniser',
        tedarikciFirmaId: 'f-051', tur: 'Tezgah', model: 'Mermer - Calacatta', renk: 'Beyaz Damarlı',
        miktar: 12, birim: 'adet', birimFiyat: 18000, toplamFiyat: 216000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A Blok',
        not: 'Premium daireler için mermer tezgah', createdAt: '2026-01-16T14:00:00Z', updatedAt: '2026-01-16T14:00:00Z',
    },
    {
        id: 'mt-007', siparisTarihi: '2026-01-17', teslimTarihi: null, tedarikci: 'Linea Mobilya',
        tedarikciFirmaId: 'f-054', tur: 'Mutfak Dolabı Alt+Üst', model: 'Modern Line', renk: 'Ceviz',
        miktar: 12, birim: 'set', birimFiyat: 52000, toplamFiyat: 624000, durum: 'uretim',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A Blok',
        not: 'Özel tasarım, üretimde', createdAt: '2026-01-17T09:00:00Z', updatedAt: '2026-01-25T10:00:00Z',
    },
    {
        id: 'mt-008', siparisTarihi: '2026-01-18', teslimTarihi: null, tedarikci: 'Bosch Türkiye',
        tedarikciFirmaId: 'f-052', tur: 'Ankastre Set', model: 'Serie 8 (Fırın+Ocak+Davlumbaz)', renk: 'Siyah',
        miktar: 12, birim: 'set', birimFiyat: 45000, toplamFiyat: 540000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A Blok',
        not: 'Dolap üretimi bitince sipariş', createdAt: '2026-01-18T10:00:00Z', updatedAt: '2026-01-18T10:00:00Z',
    },
    {
        id: 'mt-009', siparisTarihi: '2026-01-14', teslimTarihi: '2026-01-22', tedarikci: 'Faber',
        tedarikciFirmaId: 'f-055', tur: 'Davlumbaz', model: 'Inca Smart C LG A52', renk: 'Gri',
        miktar: 8, birim: 'adet', birimFiyat: 6000, toplamFiyat: 48000, durum: 'teslim',
        montajDurumu: 'devam', montajlanan: 4, insaatId: 'c1', blokAdi: 'A Blok',
        not: 'A Blok gömme davlumbazları', createdAt: '2026-01-14T11:00:00Z', updatedAt: '2026-02-01T09:00:00Z',
    },
    {
        id: 'mt-010', siparisTarihi: '2026-01-19', teslimTarihi: null, tedarikci: 'Franke',
        tedarikciFirmaId: 'f-053', tur: 'Evye', model: 'Mythos MYX 110-45', renk: 'Krom',
        miktar: 24, birim: 'adet', birimFiyat: 7500, toplamFiyat: 180000, durum: 'bekliyor',
        montajDurumu: 'bekliyor', montajlanan: 0, insaatId: 'c2', blokAdi: 'A-B-C Blok',
        not: 'Tüm bloklar için evye', createdAt: '2026-01-19T08:00:00Z', updatedAt: '2026-01-19T08:00:00Z',
    },
];

// Mutfak türleri
export const mutfakTurleri = [
    { key: 'Mutfak Dolabı Alt+Üst', label: 'Mutfak Dolabı (Alt+Üst)', aciklama: 'Komple dolap seti' },
    { key: 'Tezgah', label: 'Tezgah', aciklama: 'Granit/mermer/akrilik' },
    { key: 'Ankastre Set', label: 'Ankastre Set', aciklama: 'Fırın+Ocak+Davlumbaz' },
    { key: 'Evye', label: 'Evye', aciklama: 'Mutfak evyesi' },
    { key: 'Davlumbaz', label: 'Davlumbaz', aciklama: 'Gömme/ada tip davlumbaz' },
];

// İstatistikler
export const getMutfakStats = (insaatId) => {
    const filtered = insaatId
        ? mutfakSiparisler.filter(s => s.insaatId === insaatId)
        : mutfakSiparisler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const montajlanan = filtered.reduce((acc, s) => acc + (s.montajlanan || 0), 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return { toplamKalem, teslimEdilen, montajlanan, toplamMaliyet };
};

// Helper
export const getMutfakByInsaat = (insaatId) => {
    if (!insaatId) return mutfakSiparisler;
    return mutfakSiparisler.filter(s => s.insaatId === insaatId);
};
